import axios from 'axios';
import {routes} from "../routes/routes";
import {signOut} from "../auth";
import useAuth from '../useAuth';

export const useAxiosInstance = () => {
    const { claim, idToken } = useAuth();
    const axiosInstance = axios.create({
        baseURL: claim?.baseUrl || process.env.REACT_APP_API_URL || '',
        headers: {
            'Accept': 'application/json',
            'Authorization': idToken ? `Bearer ${idToken}` : '',
        }
    });

    axiosInstance.interceptors.response.use((response) => {
            return response;
        }, (error) => {
            console.error(error);
            if (error.response.status === 401) {
                signOut(() => {
                    window.location = routes.login;
                });
                // window.location = routes.login;
            }
        }
    );

    return {
        axiosInstance,
    };
};
